<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Dedication">“There is no hunting like the hunting of man, and those who have hunted armed men long enough and liked it, never care for anything else thereafter.” <br/>—Ernest Hemingway</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Rosen_BayouStrangler_4P-4b.vue?28b9593a